export default __webpack_public_path__ + "static/media/1567.79f8ad40.png";